



















import { Component, Vue } from 'vue-property-decorator';
import { Mutation, State, namespace } from 'vuex-class';
import Notification from './item.vue';

const NotificationsNS = namespace('notifications');

@Component({
  components: {
    Notification
  },
})
export default class Notifications extends Vue {

  @NotificationsNS.State('display') protected displayNotificationsList: any;

  @NotificationsNS.Mutation('remove') protected removeNotification: any;

}

